import axios from 'axios'

let date = new Date()
let month = date.getMonth()+1
month = month > 9 ? month : `0${month}`
let day = date.getDate()
day = day > 9 ? day : `0${day}`

date = `${day}/${month}/${date.getFullYear()}`

export const newExperience = () =>
axios.post(`${window.URL_EXPERIENCE_SERVICE}experience/create`, {
    title: `Academia sem nome - ${date}`,
    kind: 'gym',
    duration: 'Dia inteiro',
    placeType: 'indoor',
    intensity: 2
})

export const saveExperience = (token, fields) =>
axios.post(`${window.URL_EXPERIENCE_SERVICE}experience/save/${token}`, fields)

export const experienceTypes = () =>
axios.get(`${window.URL_EXPERIENCE_SERVICE}experience/types`)

export const loadStructure = () =>
axios.get(`${window.URL_EXPERIENCE_SERVICE}experience/structure`)

export const saveExperienceAddress = (token, fields) =>
axios.post(`${window.URL_EXPERIENCE_SERVICE}experience/address/${token}`, fields)

export const saveExperienceprofile = (token, fields) =>
axios.post(`${window.URL_EXPERIENCE_SERVICE}experience/profile/${token}`, fields)


export const uploadImage = (token, { file, isCover = 0, progress }) => {
    let form = new FormData()
    form.append('cover', isCover)
    form.append('image', file)
    return axios.post(window.URL_EXPERIENCE_SERVICE + 'experience/image/create/' + token, form, {
        onUploadProgress: progressEvent => {
            let percentCompleted = Math.floor((progressEvent.loaded * 100) / progressEvent.total);
            progress(percentCompleted)
        }
   })
 }
 

export const deleteImage = (token, id) =>
axios.post(`${window.URL_EXPERIENCE_SERVICE}experience/image/remove/${token}`, { id })

export const findExperiences = () =>
axios.post(`${window.URL_EXPERIENCE_SERVICE}experience/search`, {
    "statuses[0]": 1,
    "statuses[1]": 2,
    "statuses[2]": 3,
    start: 0,
    limit: 50
})

export const deleteExperience = id =>
axios.post(`${window.URL_EXPERIENCE_SERVICE}experience/remove/${id}`)


export const experienceToApproval = id =>
axios.post(`${window.URL_EXPERIENCE_SERVICE}experience/approval/${id}`)

export const experienceFind = token =>
axios.get(`${window.URL_EXPERIENCE_SERVICE}experience/find/${token}`)

export const publishExperience = id =>
axios.post(`${window.URL_EXPERIENCE_SERVICE}experience/publish/${id}`)

export const addDate = (token, form) =>
axios.post(`${window.URL_EXPERIENCE_SERVICE}calendar/date/add/${token}`, JSON.stringify(form), {
    headers: {
        'Content-Type': 'application/json',
    }
})

export const loadDates = token =>
axios.get(`${window.URL_EXPERIENCE_SERVICE}calendar/find/${token}`)

export const loadDate = (token, id) =>
axios.post(`${window.URL_EXPERIENCE_SERVICE}calendar/date/find/${token}`, JSON.stringify({id}), {
    headers: {
        'Content-Type': 'application/json',
    }
})

export const removeDate = (token, id) =>
axios.post(`${window.URL_EXPERIENCE_SERVICE}calendar/date/remove/${token}`, JSON.stringify({id}), {
    headers: {
        'Content-Type': 'application/json',
    }
})


// WEBPACK FOOTER //
// ./src/App/pages/CreateGym/_utils.js